import Layout from '@/apps/layout/components'
import LeadersContacts from '@/apps/LeadersContacts'
import React from 'react'

const LeadersContactsPage = (): React.ReactElement => {
  return (
    <Layout>
      <LeadersContacts />
    </Layout>
  )
}

export default LeadersContactsPage
